// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>10</span>&nbsp;&nbsp;The fear of the Lord is the beginning of wisdom;<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a good understanding have those who live by it;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;his praise endures for ever.<br> </p> </div></div>";
// Exports
module.exports = code;